import { getUrlFromLocale } from 'utils/locale';

export const localizeAbsoluteUrl = (
  originalPath: string,
  locale: string,
  host: string
) => {
  const path = originalPath.replace(/^\//, ''); // Remove leading slash
  const localizedPath = `${getUrlFromLocale(locale)}/${path}`;
  const hostPrefix = host.startsWith('localhost') ? 'http://' : 'https://';
  const absoluteHost = `${hostPrefix}${host}`;

  return `${absoluteHost}${localizedPath}`;
};
